import { graphql } from "@/lib/gql/__generated__";

export const DISCOUNT_MULTI_FOR_MULTI_CREATE_MUTATION = graphql(/* GraphQL */ `
	mutation discountMultiForMultiCreate($input: DiscountMultiInput!) {
		discountMultiCreate(input: $input) {
			userErrors
		}
	}
`);
